module.exports = __webpack_public_path__ + "static/img/6bg_6.ce3a272.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_6.png
// module id = 741
// module chunks = 1